import React, { useEffect, useState } from 'react';
import {
	Container,
	Paper,
	Typography,
	Grid,
	List,
	ListItem,
	ListItemText,
	TextField,
	Button,
	makeStyles,
} from '@material-ui/core';
import {
	useGetEmailTemplatesQuery,
	useUpdateEmailTemplateMutation,
} from '../../../store/apiSlice';

const useStyles = makeStyles((theme) => ({
	container: {
		marginTop: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	list: {
		width: '100%',
	},
	listItem: {
		'&.Mui-selected': {
			backgroundColor: theme.palette.action.selected,
		},
	},
	textArea: {
		width: '100%',
		marginTop: theme.spacing(2),
	},
	saveButton: {
		marginTop: theme.spacing(2),
	},
}));

// Default templates for each status

export function EmailTemplateEditPage() {
	const classes = useStyles();
	const { data, isLoading, isError } = useGetEmailTemplatesQuery();
	const [updateEmailTemplate] = useUpdateEmailTemplateMutation();

	console.log(data);

	const [selectedStatus, setSelectedStatus] = useState(0);
	const [templateValue, setTemplateValue] = useState('');

	// Current content is the template for the selected status

	const handleStatusClick = (status) => {
		setTemplateValue(data[status].text);
		setSelectedStatus(status);
	};

	const handleSave = async () => {
		// Here you can add code to persist the template content, e.g., an API call.
		console.log('Saving');

		await updateEmailTemplate({
			id: data[selectedStatus].id,
			text: templateValue,
		});
	};

	useEffect(() => {
		if (!isLoading) {
			setTemplateValue(data[selectedStatus].text);
		}
	}, [isLoading]);

	return (
		<Container maxWidth="md" className={classes.container}>
			<Typography variant="h4" gutterBottom>
				Редактиране на шаблон за имейл
			</Typography>
			<Paper className={classes.paper}>
				<Grid container spacing={2}>
					{/* Left side: Status list */}
					<Grid item xs={12} sm={4} md={3}>
						<List component="nav" className={classes.list}>
							{data &&
								data.map((status, i) => (
									<ListItem
										key={status.id}
										button
										selected={selectedStatus === i}
										onClick={() => handleStatusClick(i)}
										classes={{ root: classes.listItem }}
									>
										<ListItemText primary={status.name} />
									</ListItem>
								))}
						</List>
					</Grid>

					{/* Right side: Template form */}
					<Grid item xs={12} sm={8} md={9}>
						<Typography variant="subtitle1">Template content*</Typography>
						<TextField
							className={classes.textArea}
							multiline
							minRows={10}
							variant="outlined"
							value={templateValue}
							onChange={(e) => setTemplateValue(e.target.value)}
						/>
						<Button
							variant="contained"
							color="primary"
							className={classes.saveButton}
							onClick={handleSave}
						>
							Запис
						</Button>
					</Grid>
				</Grid>
			</Paper>
		</Container>
	);
}
